import React from 'react';

import { cn } from '@/src/util/ui';

import Tooltip from '../Tooltip/Tooltip';

type ImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  id?: string;
  className?: string;
  widthClasses?: string;
  heightClasses?: string;
  src: string;
  tooltip?: {
    place?: string;
    effect?: string;
    content?: React.ReactNode;
  };
  showTooltip?: boolean;
  children?: React.ReactNode;
};

const InlineImage = ({
  id,
  className,
  src,
  tooltip,
  widthClasses = 'tw-w-[24px]',
  heightClasses = 'tw-min-h-[24px]',
  children,
  ...otherProps
}: ImageProps) => {
  const containerProps = {
    ...otherProps,
    className: cn(
      'inlineImage--container',
      'tw-relative',
      'tw-bg-no-repeat tw-bg-contain tw-bg-center',
      'tw-flex tw-items-center',
      'tw-p-0',
      className,
      widthClasses && widthClasses,
      heightClasses && heightClasses
    ),
    'data-tip': tooltip ? true : false,
    'data-tooltip-id': tooltip ? `inlineTooltip--container_${id}` : null,
  };
  return (
    <React.Fragment>
      <div {...containerProps} style={{ backgroundImage: src }}>
        {children}

        {tooltip && (
          <Tooltip
            id={`inlineTooltip--container_${id}`}
            place={tooltip.place || 'bottom'}
            effect={tooltip.effect || 'solid'}
          >
            {tooltip.content}
          </Tooltip>
        )}
      </div>
    </React.Fragment>
  );
};

export default InlineImage;
